export default __webpack_public_path__ + "static/media/bkg--interiors-2.99eaea13.jpg";